export interface UpgradePreviewRequestIdentity {
  couponMode: "policy" | "without_coupon";
  requestId: string;
  selectedPaywallPriceId?: number;
}

export const isCurrentUpgradePreviewRequest = (
  response: UpgradePreviewRequestIdentity,
  current?: UpgradePreviewRequestIdentity,
): boolean =>
  Boolean(
    current &&
    current.requestId === response.requestId &&
    current.couponMode === response.couponMode &&
    current.selectedPaywallPriceId === response.selectedPaywallPriceId,
  );
